import { resolveSemanticColor } from '@/theme/semanticTokens';
import type { Theme } from './types';

export const resolveChartPlotAreaBackgroundColor = (theme: Theme): string =>
  theme.palette.mode === 'light'
    ? resolveSemanticColor(theme, 'surfacePaper')
    : resolveSemanticColor(theme, 'surfaceInset');
